import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { keyframes } from "@emotion/react";
import { Aurora, Iceberg, Avalanche, Netzero, One1, Visva } from "../../constant";
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';

const scrollAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export default function HorizontalInfiniteScroll() {
  const [hover, setHover] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const originalItems = [
    { image: One1, text: "One" },
    { image: Visva, text: "Visva" },
    { image: Aurora, text: "Aurora" },
    { image: Iceberg, text: "Iceberg" },
    { image: Avalanche, text: "Avalanche" },
    { image: Netzero, text: "NetZero" },
  ];
  const items = [...originalItems, ...originalItems];

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        padding: "16px 0",
        background: "linear-gradient(180deg, rgba(0, 159, 245, 0) 5%, #009FF5 129.82%)",
        position: "relative",
        textAlign: "center",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Slide Up Text with Icon Below */}
      <Box
        sx={{
          position: "absolute",
          top: hover ? "50%" : "130%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          fontSize: "24px",
          color: "white",
          transition: "top 0.3s ease-in-out",
          zIndex: 10,
        }}
      >
        <Typography
          onClick={() =>
            window.scrollBy({
              top: 700,
              behavior: "smooth",
            })
          }
          sx={{
            cursor: "pointer",
          }}
        >
          Click to Know More!
        </Typography>
        <KeyboardDoubleArrowDownOutlinedIcon fontSize="large" />
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "max-content",
          animation: `${scrollAnimation} 15s linear infinite`,
          "&:hover": { animationPlayState: "paused" },
          padding: "0 12px",
          gap: isMobile ? 0 : 3,
          position: "relative",
          filter: hover ? "blur(8px)" : "none",
          transition: "filter 0.4s ease-in-out",
          pointerEvents: hover ? "none" : "auto",
        }}
      >
        {items?.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              padding: "10px 20px",
              flexShrink: 0,
              borderRadius: "10px",
              backgroundColor: "transparent",
              transition: "transform 0.6s ease",
              "&:hover": { transform: "scale(1.1)" },
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={item.text}
              sx={{
                width: 50,
                height: 50,
                borderRadius: "8px",
              }}
            />
            {!isMobile && (
              <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "white" }}>
                {item.text}
              </Typography>
            )}

          </Box>
        ))}
      </Box>
    </Box>
  );
}
